import api from './api';

// İki adımlı doğrulama — self-servis (Profil → Hesap Güvenliği).
export const getMfaStatus = () => api.get('/v1/auth/mfa');
export const sendMfaSetupCode = () => api.post('/v1/auth/mfa/setup/send-code');
export const startMfaSetup = (data) => api.post('/v1/auth/mfa/setup/start', data);
export const confirmMfaSetup = (code) => api.post('/v1/auth/mfa/setup/confirm', { code });
export const regenerateRecoveryCodes = (code) => api.post('/v1/auth/mfa/recovery-codes', { code });
export const disableMfa = (code) => api.post('/v1/auth/mfa/disable', { code });
export const revokeTrustedBrowsers = () => api.post('/v1/auth/mfa/trusted-browsers/revoke');

// Yönetici: çalışanın iki adımlı doğrulaması.
export const getEmployeeMfaStatus = (employeeId) => api.get(`/v1/employees/${employeeId}/mfa`);
export const resetEmployeeMfa = (employeeId) => api.post(`/v1/employees/${employeeId}/mfa/reset`);
